// Geo currency for the popup (GET /payments/currency, resolved by IP) — the
// same endpoint the platform's useCurrentCurrency falls back to. The Upgate
// charge currency is assigned from the same geo lookup at registration, so the
// symbol shown here always matches what the checkout actually charges.
import { useEffect, useState } from 'react';

const API_BASE_URL = `${process.env.REACT_APP_SWIPEY_BASE_URL}/api/v1`;
const API_KEY = process.env.REACT_APP_API_KEY;

const USD = { symbol: '$', code: 'USD' };

// → { symbol, code }; USD until (or unless) the geo lookup answers.
export function useCurrentCurrency() {
  const [currency, setCurrency] = useState(USD);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/payments/currency`, {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY,
          },
        });
        const data = await res.json();
        if (!cancelled && res.ok && data?.symbol && data?.code) {
          setCurrency({ symbol: data.symbol, code: data.code });
        }
      } catch (err) {
        if (!cancelled) {
          console.warn('[paywall-popup] currency fetch failed', err);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return currency;
}
